import {showErrorSnackBar} from "@/utils/SnackBartHelper";
import Rules from "@/utils/Rules";
import EnvelopeService from '@/services/server/EnvelopeService';

const createEnvelopeData = () => {
    return {
        name: null,
        locale: "pt-BR",
        auto_close: true,
        block_after_refusal: false,
        remind_interval: "3",
        default_subject: null,
        default_message: null,
        deadline_at: null,
    }
}

export default {
    name: 'NewEnvelopeModal',
    props: {
        openModal: {
            type: Boolean,
            default: false
        },
        closeFunc: {
            type: Function,
            default: () => {}
        }
    },
    components: {},
    data: () => ({
        dialog: true,
        isLoading: false,
        isValidForm: true,
        envelope: createEnvelopeData(),
        intervalReminder: [
            {text: "Sem Lembrete", value: null},
            {text: "1", value: "1"},
            {text: "2", value: "2"},
            {text: "3", value: "3"},
            {text: "7", value: "7"},
            {text: "14", value: "14"},
        ]
    }),
    computed: {
        ruleRequired() {
            return Rules.required();
        },
    },
    watch: {},
    methods: {
        onInputDate(value) {
            value = value.replace(/[^0-9/: ]/g, "");

            if (value.length <= 2) {
                value = value.replace(/^(\d{0,2})/, "$1");
            } else if (value.length <= 5) {
                value = value.replace(/^(\d{2})\/?(\d{0,2})/, "$1/$2");
            } else if (value.length <= 10) {
                value = value.replace(/^(\d{2})\/(\d{2})\/?(\d{0,4})/, "$1/$2/$3");
            } else if (value.length <= 13) {
                value = value.replace(/^(\d{2})\/(\d{2})\/(\d{4})\s?(\d{0,2})/, "$1/$2/$3 $4");
            } else {
                value = value.replace(/^(\d{2})\/(\d{2})\/(\d{4})\s(\d{2}):?(\d{0,2})/, "$1/$2/$3 $4:$5");
            }

            this.envelope.deadline_at = value;
        },
        onKeyPressDate(event) {
            const allowedChars = /[0-9:]/;
            if (!allowedChars.test(event.key)) {
                event.preventDefault();
            }
        },
        async createEnvelope() {
            try {
                if (this.$refs.envelopeForm.validate()) {
                    this.isLoading = true;
                    const result = await EnvelopeService.createEnvelope(this.envelope);
                    await this.$router.push(`/signatures/${result.data.data.id_doc}`)
                    this.closeFunc();
                } else {
                    showErrorSnackBar("Existem Pendências no formulário!");
                }
            } catch (e) {
                showErrorSnackBar("Erro inesperado, contacte o suporte")
            } finally {
                this.isLoading = false;
            }

        }
    },
}